import { createOrderPIX } from './createOrderPIX';
import { createCustomer } from './createCustomer';
import { createOrder } from './createOrder';
import { createExtraAmount } from './createExtraAmount';

import { updateCredCard } from './updateCredCard';

import { getCardHash } from './getCardHash';
import { listOrders } from './listOrders';
import { unlockBike } from './helpers/unlockBike';

export const errFnc: (reason: any) => void | PromiseLike<void> = i =>
  console.log('err pagar.me', i);

export const pagarme = {
  createExtraAmount,
  createCustomer,
  createOrderPIX,
  createOrder,

  updateCredCard,

  listOrders,
  getCardHash,
  unlockBike,
};
